module.exports = __webpack_public_path__ + "videos/banner.c70c664.mp4";